// extracted by mini-css-extract-plugin
export var browseMoreNav = "page-preview-grid-module--browseMoreNav--e91b9 typography-module--small--2877f";
export var grid3Col = "page-preview-grid-module--grid3Col--71ccb";
export var headline = "page-preview-grid-module--headline--e1a42 typography-module--title2--9ffee";
export var root = "page-preview-grid-module--root--457cc";